/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { api } from "api";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import Pagination from "react-js-pagination";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import { Trans } from "react-i18next";
import i18next from "i18next";
import Helpers from "util/helpers";
import AvailableTraining from "./AvailableTraining";

class AvailableTrainings extends Component {
  state = {
    trainings: [],
    filteredData: [],
    filterTerm: "",
    error: null,
    activePage: 1,
    sort_by: "trName", // training name by default
    sort_dir: "desc",
    showELearnings: false,
  };

  settings = {
    itemsPerPage: 10,
  };

  trType = "";
  trName = "";
  trLocation = "";
  trStartDate = "";
  trEndDate = "";
  trPackage = "";

  reOrder = (orderBy) => {
    let sort_dir = "asc";
    if (this.state.sort_dir === "asc") sort_dir = "desc";
    this.setState({
      sort_by: orderBy,
      sort_dir: sort_dir,
    });
  };

  setSotingClassNames = () => {
    this.trType = "";
    this.trName = "";
    this.trLocation = "";
    this.trStartDate = "";
    this.trEndDate = "";
    this.trPackage = "";
    switch (this.state.sort_by) {
      case "trType":
        this.trType = `_${this.state.sort_dir}`;
        break;
      case "trName":
        this.trName = `_${this.state.sort_dir}`;
        break;
      case "trLocation":
        this.trLocation = `_${this.state.sort_dir}`;
        break;
      case "trStartDate":
        this.trStartDate = `_${this.state.sort_dir}`;
        break;
      case "trEndDate":
        this.trEndDate = `_${this.state.sort_dir}`;
        break;
      case "trPackage":
        this.trPackage = `_${this.state.sort_dir}`;
        break;
      default:
        this.trName = `_${this.state.sort_dir}`;
        break;
    }
  };

  componentDidMount() {
    this.fetchData({ elearning: false });
  }

  fetchData({ elearning }) {
    this.props.onProcessBegin();

    api
      .get(
        "/api/training/get-available-trainings?elearning=" +
        elearning.toString()
      )
      .then((response) => {
        this.setState({
          trainings: response.data.data.trainings,
          filteredData: response.data.data.trainings,
          activePage: 1,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  }

  checkBoxHandleChange = (checked) => {
    this.fetchData({ elearning: checked });
    this.setState({ showELearnings: checked });
  };

  componentDidUpdate(prevProps, prevState) {
    // if (prevProps.employees !== this.props.employees) {
    //   this.setState({ filteredData: this.props.employees });
    // }

    if (this.state.filterTerm !== prevState.filterTerm) {
      this.setState({
        filteredData: this.state.trainings.filter((item) => {
          return Helpers.getTurkishCharaterFixedList(
            item.training.name
          ).includes(
            Helpers.getTurkishCharaterFixedList(this.state.filterTerm)
          );
        }),
        activePage: 1,
      });
    }
  }

  handlePageChange = (pageNum) => {
    this.setState({ activePage: pageNum });
  };

  handleFilter = (e) => {
    this.setState({ filterTerm: e.target.value, activePage: 1 });
  };

  renderSearchBar = () => {
    return (
      <div className="col-xs-12 col-sm-12 col-md-3 col-lg-4 tableSearchArea">
        <div className="inner-addon right-addon">
          <span className="iconmford fo-icon-search"></span>
          <input
            type="text"
            name="tableSearch"
            id="tableSearch"
            className="form-control"
            placeholder={i18next.t("10053")}
            onChange={(e) => this.handleFilter(e)}
            value={this.state.filterTerm}
          />
        </div>
      </div>
    );
  };

  renderHeaderToolbar = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginRight: "20px",
          marginLeft: "20px",
        }}
      >
        {this.renderSearchBar()}

        <Pagination
          hideFirstLastPages={true}
          prevPageText={i18next.t(10110)}
          nextPageText={i18next.t(10111)}
          hideDisabled={true}
          hideNavigation={true}
          activePage={this.state.activePage}
          itemsCountPerPage={this.settings.itemsPerPage}
          totalItemsCount={
            this.state.filteredData?.length > 0
              ? this.state.filteredData.length
              : 0
          }
          onChange={(e) => this.handlePageChange(e)}
          itemClass="page-item"
          linkClass="page-link"
        />
      </div>
    );
  };

  renderFooterToolbar = () => {
    return <div className="table-footer-toolbar mt-4 mb-4"></div>;
  };

  renderData = (start, end) => {
    const sorted = this.state.filteredData.sort((a, b) => {
      switch (this.state.sort_by) {
        case "trName":
          return this.state.sort_dir === "desc"
            ? a.training.name.localeCompare(b.training.name)
            : b.training.name.localeCompare(a.training.name);
        case "trLocation":
          return this.state.sort_dir === "desc"
            ? (a.trainingLocation ?? "").localeCompare(b.trainingLocation ?? "")
            : (b.trainingLocation ?? "").localeCompare(
              a.trainingLocation ?? ""
            );
        case "trStartDate":
          return this.state.sort_dir === "desc"
            ? new Date(a.startDate ?? 0) - new Date(b.startDate ?? 0)
            : new Date(b.startDate ?? 0) - new Date(a.startDate ?? 0);
        case "trEndDate":
          return this.state.sort_dir === "desc"
            ? new Date(a.endDate ?? 0) - new Date(b.endDate ?? 0)
            : new Date(b.endDate ?? 0) - new Date(a.endDate ?? 0);
        case "trType":
          return this.state.sort_dir === "desc"
            ? a.trainingMethod.label.localeCompare(b.trainingMethod.label)
            : b.trainingMethod.label.localeCompare(a.trainingMethod.label);
        case "trPackage":
          return this.state.sort_dir === "desc"
            ? a.packageTimePlan?.name.localeCompare(b.packageTimePlan?.name)
            : b.packageTimePlan?.name.localeCompare(a.packageTimePlan?.name);
        default:
          return this.state.sort_dir === "desc"
            ? a.training.name.localeCompare(b.training.name)
            : b.training.name.localeCompare(a.training.name);
      }
      // return 1;
    });

    return sorted.slice(start, end).map((t) => {
      return <AvailableTraining key={t.key} t={t} />;
    });
  };

  render() {
    this.setSotingClassNames();
    let start = this.settings.itemsPerPage * (this.state.activePage - 1);
    let end = start + this.settings.itemsPerPage;
    return (
      <>
        {this.props.spinner}
        <div>{this.renderHeaderToolbar()}</div>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginRight: "20px",
            marginLeft: "20px",
          }}
        >
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input"
              id="elearning-box"
              onChange={(e) =>
                this.checkBoxHandleChange(e.currentTarget.checked)
              }
            />
            <label
              className="custom-control-label pl-0 formClickArea"
              htmlFor="elearning-box"
            >
              <span>E-Öğrenmeleri Göster/Gizle</span>
            </label>
          </div>
        </div>
        <div
          className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
          id="kayitliEgitimler"
          style={{ display: "block" }}
        >
          <table
            className="table display responsive tgE dataTable no-footer dtr-none collapsed"
            id="dataTablePersonel"
          >
            <thead>
              <tr>
                <th
                  onClick={() => this.reOrder("trType")}
                  className={`all sorting${this.trType}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Tür">10014</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trName")}
                  className={`all sorting${this.trName}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Eğitim Adı">10015</Trans>
                  </div>
                </th>
                <DesktopBreakpoint>
                  <th
                    onClick={() => this.reOrder("trLocation")}
                    className={`desktop sorting${this.trLocation}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Yer">10016</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trStartDate")}
                    className={`desktop sorting${this.trStartDate}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Başlangıç">10020</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trEndDate")}
                    className={`desktop sorting${this.trEndDate}`}
                  >
                    <div className="tableTitle">
                      <Trans desc="Bitiş">10021</Trans>
                    </div>
                  </th>
                  <th
                    onClick={() => this.reOrder("trPackage")}
                    className={`desktop sorting${this.trPackage}`}
                  >
                    <div className="tableTitle"></div>
                  </th>
                </DesktopBreakpoint>
              </tr>
            </thead>
            <tbody>{this.renderData(start, end)}</tbody>
          </table>
        </div>
      </>
    );
  }
}

export default containsLongRunningProcess(requireAuth(AvailableTrainings));
